import { render, staticRenderFns } from "./ProfessionalFees.vue?vue&type=template&id=5231b132&scoped=true"
import script from "./ProfessionalFees.vue?vue&type=script&lang=js"
export * from "./ProfessionalFees.vue?vue&type=script&lang=js"
import style0 from "./ProfessionalFees.vue?vue&type=style&index=0&id=5231b132&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5231b132",
  null
  
)

export default component.exports